import React from 'react';
import { Box, Grid, Skeleton } from '@mui/material';
import './DashboardSkeleton.scss';

const shimmer = { animation: 'wave' };

export const DashboardKpiSkeleton = () => (
  <Grid container spacing={3} alignItems="stretch">
    {[0, 1, 2, 3].map((i) => (
      <Grid item xs={12} sm={6} md={3} key={i}>
        <Skeleton
          variant="rounded"
          height={108}
          sx={{ borderRadius: 3 }}
          {...shimmer}
        />
      </Grid>
    ))}
  </Grid>
);

export const DashboardSideStatsSkeleton = () => (
  <Box className="dashboard-skeleton-side">
    <Skeleton variant="rounded" height={92} sx={{ borderRadius: 2.5, mb: 1.5 }} {...shimmer} />
    <Box className="dashboard-skeleton-side__row">
      <Skeleton variant="rounded" height={76} sx={{ borderRadius: 2.5, flex: 1 }} {...shimmer} />
      <Skeleton variant="rounded" height={76} sx={{ borderRadius: 2.5, flex: 1 }} {...shimmer} />
    </Box>
    {[0, 1, 2, 3].map((i) => (
      <Skeleton
        key={i}
        variant="rounded"
        height={64}
        sx={{ borderRadius: 2.5, mb: 1.5 }}
        {...shimmer}
      />
    ))}
  </Box>
);

export const DashboardChartSkeleton = ({ height = 300, titleWidth = '35%' }) => (
  <Box className="dashboard-skeleton-chart">
    <Skeleton variant="rounded" width={titleWidth} height={26} sx={{ mb: 2 }} {...shimmer} />
    <Box className="dashboard-skeleton-chart__bars" style={{ height }}>
      <Skeleton variant="rounded" width="100%" height="100%" sx={{ borderRadius: 2 }} {...shimmer} />
    </Box>
  </Box>
);

export const DashboardModuleSkeleton = () => (
  <Box className="dashboard-skeleton dashboard-skeleton--module">
    <Grid container spacing={2} sx={{ mb: 3 }}>
      {[0, 1, 2, 3].map((i) => (
        <Grid item xs={12} sm={6} md={3} key={i}>
          <Skeleton variant="rounded" height={88} sx={{ borderRadius: 2 }} {...shimmer} />
        </Grid>
      ))}
    </Grid>
    <Skeleton variant="rounded" height={56} sx={{ borderRadius: 2, mb: 3 }} {...shimmer} />
    <Grid container spacing={3}>
      <Grid item xs={12} lg={8}>
        <Box className="dashboard-skeleton-panel">
          <DashboardChartSkeleton height={340} />
        </Box>
      </Grid>
      <Grid item xs={12} lg={4}>
        <Box className="dashboard-skeleton-panel">
          <DashboardSideStatsSkeleton />
        </Box>
      </Grid>
    </Grid>
    <Box className="dashboard-skeleton-panel" sx={{ mt: 3 }}>
      <Skeleton variant="rounded" width="28%" height={24} sx={{ mb: 2 }} {...shimmer} />
      <Skeleton variant="rounded" height={200} sx={{ borderRadius: 2 }} {...shimmer} />
    </Box>
  </Box>
);

const DashboardSkeleton = ({ showKpi = true }) => (
  <Box className="dashboard-skeleton">
    {showKpi && <DashboardKpiSkeleton />}
    <Grid container spacing={3} sx={{ mt: 2 }}>
      <Grid item xs={12} md={4}>
        <DashboardSideStatsSkeleton />
      </Grid>
      <Grid item xs={12} md={8}>
        <Box className="dashboard-skeleton-panel">
          <DashboardChartSkeleton height={300} />
          <Box sx={{ mt: 3 }}>
            <DashboardChartSkeleton height={280} titleWidth="42%" />
          </Box>
        </Box>
      </Grid>
    </Grid>
  </Box>
);

export default DashboardSkeleton;
